import {
  Sparkle,
  Palette,
  TextAa,
  Ruler,
  Square,
  StackSimple,
  PaintBrush,
  Shapes,
  Lightning,
  PuzzlePiece,
  Heart,
  Devices,
} from "@phosphor-icons/react";

export const NAV_ITEMS = [
  { id: "overview", label: "Overview", icon: Sparkle },
  { id: "colour", label: "Colour", icon: Palette },
  { id: "typography", label: "Typography", icon: TextAa },
  { id: "spacing", label: "Spacing", icon: Ruler },
  { id: "radius", label: "Radius", icon: Square },
  { id: "elevation", label: "Elevation", icon: StackSimple },
  { id: "illustration", label: "Illustration", icon: PaintBrush },
  { id: "icons", label: "Iconography", icon: Shapes },
  { id: "motion", label: "Motion", icon: Lightning },
  { id: "components", label: "Components", icon: PuzzlePiece },
  { id: "accessibility", label: "Accessibility", icon: Heart },
  { id: "responsive", label: "Responsive", icon: Devices },
];
